export default __webpack_public_path__ + "static/media/exportData.eea4f72c.svg";